define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("CloseRevision", _StateAction, {
		_bLatestRevision: false,
		m_tag: "CloseRevision"
	});
});